export default function buildHref(url) {
  if (!/^(?:f|ht)tps?:\/\//.test(url)) {
    return `http://${url}`;
  }
  return url;
}
